import Button from 'components/forms/Button'
import MediaCard from './common/MediaCard'
import Link from 'next/link'
import { Tenant } from 'common/tenant'

const SaaSOfficeSolutionCard = ({ tenant = Tenant.UK }: { tenant?: Tenant }) => {
  return (
    <MediaCard
      imageContainerWidth={'40%'}
      imageFitPreset="cover-left"
      layout={{ mobile: 'content-top-media-bottom' }}
      image={{
        alt: 'HaiRo™ left arm and leg',
        desktop: {
          dimensions: {
            height: 600,
            width: 550,
          },
          src: '/images/new/robot-left-arm-and-leg.png',
        },
        mobile: {
          dimensions: {
            height: 328,
            width: 361,
          },
          src: '/images/new/robot-upperhalf.png',
        },
      }}
    >
      <div
        className='d-flex flex-1 flex-column px-4 pt-8 pb-0 pe-lg-0 ps-lg-20 pt-lg-9 pb-lg-6 fw-semibold'
      >
        <h2 className='fw-semibold mb-6 fs-fluid-36-80 lh-105'>
          For Partners and Enterprise Solutions.
        </h2>
        <div
          className='lh-132 fs-fluid-18-22'
        >
          <h3 className='fw-semibold fs-fluid-20-28 mb-0'>
            A virtual office SaaS service for your clients.
          </h3>
          <br />
          <span>
            Create Your Own virtual office solution to expand your client
            service offering with our SaaS solution. Our solution includes a
            virtual business address, which enhances professionalism and trust
            while safeguarding personal information. Generate an incremental
            revenue stream, increase efficiency and expand your client
            proposition.
          </span>
        </div>
        <Link className='align-self-lg-start mt-8' href={tenant === Tenant.AU ? '/au/enterprise' : '/enterprise'}>
          <Button className='w-100 w-lg-auto'>Find Out More</Button>
        </Link>
      </div>
    </MediaCard>
  )
}

export default SaaSOfficeSolutionCard
